import React from "react";
import {ThemeProvider} from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";

import MuiInputTheme from "@/themes/mui/MuiInputTheme.js";

export default function ErrorLabel({children, ...props}) {
    return (
        <ThemeProvider theme={MuiInputTheme}>
            <InputLabel
                id={props.name ? `${props.name}-input-label` : null}
                htmlFor={props.name ? `${props.name}-input` : null}
                error={true}
                shrink={false}
                {...props}
            >
                {children}
            </InputLabel>
        </ThemeProvider>
    );
}
